import EventBus from './lib/eventBus'

const $modals = new EventBus()

export { $modals }
